import React, { useState } from "react";
import "./styles.css";
import { Tab, Tabs } from "react-tabs";

const TabComponent2 = ({ data, children }) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Tabs
      className='react-tabs__tab-list'
      selectedIndex={tabIndex}
      onSelect={(index) => setTabIndex(index)}
    >
      <div className='container'>
        <div className='row'>
          <div className='wrap' id='wrap-yellow'>
            <ul className='nav-yellow'>
              {data.map((title, index) => {
                return (
                  <Tab
                    key={index}
                    className={index === tabIndex ? "nav-yellow-active" : null}
                  >
                    {title}
                  </Tab>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      {children}
    </Tabs>
  );
};

export default TabComponent2;
